import React from 'react';
import Inquisitive6to82024 from 'views/Inquisitive6to82024';
const SchoolProgrampage = () => {
  return <Inquisitive6to82024 />;
};

export default SchoolProgrampage;